module.exports = __webpack_public_path__ + "img/titleid.8b445051.png";